import { IAPIResponse } from '@api/AbstractAPI';
import { Injectable } from '@angular/core';
import { WebService } from './web.service';
import { IDashboardResult } from '@models/Dashboard';
import { IFilterList } from '@models/Content';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    private modules;

    constructor(private WebService: WebService) { }


    /**
     * 
     * @param formData 
     * @returns 
     */
    public async UploadAndGetUrl(formData: FormData) {

        const response = await this.WebService.UploadAndGetUrl(formData);

        return response;
    }


    /**
     * 
     * @param idEdition 
     * @returns 
     */
    public async GetDashboardData(idEdition: string): Promise<IAPIResponse<IDashboardResult>> {

        const response = await this.WebService.GetDashboardData(idEdition);

        return response;
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    public async GetDashboardStatistics(filters): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetDashboardStatistics(filters);

        return response;
    }

    /**
     * 
     * @returns 
     */
    public async GetGenreList(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetGenreList();

        return response;
    }


    public async GetEntity(id: string): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetEntity(id);

        return response;
    }
    /**
     * 
     * @returns 
     */
    public async GetEntityList(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetEntityList();

        return response;
    }

    /**
     * 
     * @returns 
     */
    public async GetEntityConfiguration(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetEntityConfiguration();

        return response;
    }
    /**
     * 
     * @param text 
     * @param idContinent 
     * @returns 
     */
    public async GetCountryList(text: string = "", idContinent: number = null): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetCountryList(text, idContinent);

        return response;
    }

    /**
     * 
     * @param idCampaing 
     * @param filters 
     * @returns 
     */
    public async GetBlackListItemList(idCampaing, filters = null): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetBlackListItemList(idCampaing, filters);

        return response;
    }

    /**
     * 
     */
    public async GetContentTypeList(): Promise<IAPIResponse<any>> {

        const response = await this.WebService.GetContentTypeList();

        return response;
    }

    /**
     * 
     * @returns 
     */
    public async GetAvailableWalletModuleList() {

        if (this.modules) return Promise.resolve(this.modules);

        const response = await this.WebService.GetAvailableWalletModuleList();

        this.modules = response;

        return response;
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    public async RequestList(filters: IFilterList) {

        const response = await this.WebService.RequestList(filters);

        return response;
    }
}
